import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  allArtists: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
    hasMore: true,
  },
};

export const fetchAllArtists = createAsyncThunk(
  'adminArtistsSlice/fetchAllArtists',
  async ({ page = 1, limit = 20, search = '', reset = false }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/artist/all`, {
        params: { page, limit, search },
      });

      return {
        data: response.data.data || [],
        pagination: response.data.pagination || {},
        reset,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch artists');
    }
  }
);

export const adminArtistsSlice = createSlice({
  name: 'adminArtistsSlice',
  initialState,
  reducers: {
    resetArtists: state => {
      state.allArtists = [];
      state.pagination = initialState.pagination;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAllArtists.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllArtists.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination, reset } = action.payload;
        if (reset || pagination.page === 1) {
          state.allArtists = data;
        } else {
          const existingIds = new Set(state.allArtists.map(a => a._id));
          const newArtists = data.filter(a => !existingIds.has(a._id));
          state.allArtists = [...state.allArtists, ...newArtists];
        }
        state.pagination = pagination;
      })
      .addCase(fetchAllArtists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetArtists } = adminArtistsSlice.actions;

export default adminArtistsSlice.reducer;
